export const ANSWER_COLORS = [
  { id: "red", className: "bg-red-500 hover:bg-red-600 text-white" },
  { id: "blue", className: "bg-blue-500 hover:bg-blue-600 text-white" },
  { id: "yellow", className: "bg-yellow-400 hover:bg-yellow-500 text-black" },
  { id: "green", className: "bg-green-500 hover:bg-green-600 text-white" },
] as const;

export interface QuizShowQuestion {
  prompt: string;
  imageUrl?: string;
  choices: string[];
  correctIndex: number;
}

export interface QuizShowPlayer {
  id: string;
  displayName: string;
  score: number;
}

export interface QuizShowState {
  type: "state";
  status: "waiting" | "question" | "reveal" | "ended";
  roomCode: string;
  players: QuizShowPlayer[];
  answeredCount: number;
  playerCount: number;
  question: {
    index: number;
    total: number;
    prompt: string;
    choices: string[];
    correctIndex?: number;
  } | null;
  answers: Record<string, number>;
}

export const parseQuizShowState = (raw: string | null): QuizShowState | null => {
  if (!raw) {
    return null;
  }
  try {
    const parsed: unknown = JSON.parse(raw);
    if (
      typeof parsed === "object" &&
      parsed !== null &&
      (parsed as QuizShowState).type === "state"
    ) {
      return parsed as QuizShowState;
    }
  } catch {
    return null;
  }
  return null;
};

export const shuffleItems = <T>(items: T[]): T[] => {
  const next = [...items];
  for (let index = next.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1));
    [next[index], next[swapIndex]] = [next[swapIndex], next[index]];
  }
  return next;
};
